// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jzliu-bi-engine-dws-preview[data-v-70bcd94e] {
  width: 100%;
  height: 100%;
}
[data-v-70bcd94e] .el-dialog__body {
  max-height: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/base/preview/dataChartPreview.vue","webpack://./dataChartPreview.vue"],"names":[],"mappings":"AAmEA;EACE,WAAA;EACA,YAAA;AClEF;ADqEA;EACE,gBAAA;ACnEF","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.jzliu-bi-engine-dws-preview {\n  width: 100%;\n  height: 100%;\n}\n\n/deep/ .el-dialog__body {\n  max-height: none;\n}\n",".jzliu-bi-engine-dws-preview {\n  width: 100%;\n  height: 100%;\n}\n /deep/ .el-dialog__body {\n  max-height: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
